import urlHelper from '../helpers/url'

const primerAcceso = () => {
    let combo = document.querySelector(".next-button[data-step=bannerVincular]").dataset.combo;
    console.log('primerAcceso' + combo);
    if (combo && combo!==null)
    {
        urlHelper.redirectToCombo(combo)
    }
    else
    {
        window.mostrar_error( { 
            error: `primerAcceso.primerAcceso | No se encontro el combo bonificado` 
        })
    }

}

export default primerAcceso;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/primerAcceso.js